// extracted by mini-css-extract-plugin
export var editInput = "_ih-0";
export var editInputCompact = "_ih-2";
export var editInputLarge = "_ih-1";
export var editInputSmall = "_ih-3";